/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{open as o}from"./workers/workers.js";const r=o;export{r as open};
